import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ISharedWithMeContentInfo } from '../../../../sharing/models/ISharedWithMeContentInfo';
import { deleteContentsAction } from '../../../actions/DeleteContentAction';
import { IDeleteAction as IDeleteActionApi } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { isSharedWithMeSpace, isSingleCollectionSpace, isSiteBroadcastsSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import {
  anyItemIsEmbeddedDatasource,
  userCanEditSchedule,
  userCanManageAlerts,
  userCanManageAnyCollection
} from './IEntityActionHelpers';

export const DeleteAction: IEntityAction<IContentInfo, IDeleteActionApi> = {
  name: EntityActionNames.Delete,
  translateName: Messages.delete_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return !anyItemIsEmbeddedDatasource(targetItems)
      && !isContentRelatedToSharedWithMe(targetItems, state.spaceInfo)
      && !isSiteBroadcastsSpace(state.spaceInfo); // Delete Action is hidden for Broadcasts Spaces
  },
  isClickable: (availableActions: IDeleteActionApi, targetItems: IContentInfo[], state: AppState) => {

    if (isSingleCollectionSpace(state.spaceInfo)) {
      // don't allow deleting items INSIDE a collection when in the Single Collection Space.
      // we DO want to allow deleting the actual collection if the user has "manage" permissions.
      return targetItems.length === 1 && targetItems[0].contentType === 'collection' && userCanManageAnyCollection(state, targetItems);
    }

    return (!!(availableActions && availableActions.del)
      || userCanManageAlerts(state, targetItems)
      || userCanEditSchedule(state, targetItems)
      || userCanManageAnyCollection(state, targetItems));
  },
  createReduxAction: (targetItems: IContentInfo[]) => deleteContentsAction(targetItems)
};

const isContentRelatedToSharedWithMe = (targetItems: IContentInfo[], spaceInfo: SpaceInfo): boolean =>  {
  // An action item for Shared With Me can appear in either SwM Space or Channel
  // An item will have valid 'sharedAt' only in SharedWithMe Space or Channel
  return isSharedWithMeSpace(spaceInfo) ||
   (targetItems.length > 0 && !!(targetItems[0] as ISharedWithMeContentInfo).sharedAt);
};
